import { PocProgressSpinner, PocSwitch } from 'commons/components/components-wrapper';
import React, { ReactElement } from 'react';
import { SwitchFormLayout } from './switch-form.style';

interface SwitchFormComponentProps {
    label: ReactElement;
    enabled: boolean;
    loading?: boolean;
    disabled?: boolean;
    onChange: (status: boolean) => void;
    'data-testid'?: string;
}

export const SwitchFormComponent: React.FC<SwitchFormComponentProps> = (props) => {
    const { label, enabled, disabled = false, loading = false, onChange, 'data-testid': testId } = props;

    const testIdProps = testId ? { 'data-testid': testId } : {};

    return (
        <SwitchFormLayout>
            {label}
            {loading ? (
                <PocProgressSpinner size="small" />
            ) : (
                <PocSwitch
                    checked={enabled}
                    controlled
                    onValueChange={(ev) => onChange(ev.detail)}
                    disabled={disabled}
                    {...testIdProps}
                />
            )}
        </SwitchFormLayout>
    );
};
